import * as actions from "./actionsTypes";

const initialData = {
  surveyLoading: false,
  survey: null,
  surveyFail: null,

  // Para guardar cuestionario
  surveySaveLoading: false,
  formFail: null,
};

export default function cuestionarioReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CUESTIONARIO:
      return { ...state, surveyLoading: action.payload };
    case actions.GET_CUESTIONARIO:
      return { ...state, survey: action.payload };
    case actions.CUESTIONARIO_FAIL:
      return { ...state, surveyFail: action.payload };

    // Para guardar cuestionario
    case actions.SAVE_LOADING_CUESTIONARIO:
      return { ...state, surveySaveLoading: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formFail: action.payload };
    default:
      return { ...state };
  }
}
